define('formkit/view/form.object/common/help.text.view',['require','exports','module','uikit/uikit'],function(require, exports, module) {
  var UIKit = require('uikit/uikit');

  var HelpTextView = UIKit.ItemView.extend({
    template: function() { return '<ui name="descriptionTextView" /> <ui name="helpTextInputView" />'; },

    internalViewOptions: {
      descriptionTextView: {
        type: UIKit.Text.extend({
          attributes: {
            style: 'display:block; margin:0em 0em 0.2857rem 0em; font-size:0.9285em; font-weight: bold;'
          }
        }),
        text: 'Help Text Message'
      },
      helpTextInputView: function() {
        return {
          type: UIKit.Input,
          fluid: true,
          model: this.model,
          multiLine: true,
          maxLength: 1000,
          placeholder: 'My help text message goes here...',
          rowCount: 5,
          bindings: {
            value: 'helpText'
          }
        }
      }
    }
  });

  module.exports = HelpTextView;
});

